import { render, staticRenderFns } from "./TabPetModal.vue?vue&type=template&id=505a3830&scoped=true&"
import script from "./TabPetModal.vue?vue&type=script&lang=js&"
export * from "./TabPetModal.vue?vue&type=script&lang=js&"
import style0 from "./TabPetModal.vue?vue&type=style&index=0&id=505a3830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505a3830",
  null
  
)

export default component.exports